export const generateActionType = (name) => ({
  REQUEST: `${name}_REQUEST`,
  SUCCESS: `${name}_SUCCESS`,
  FAILURE: `${name}_FAILURE`,
})

export const PROJECT_NAME = generateActionType('PROJECT_NAME')
export const PROJECT_NAME_ADD = generateActionType('PROJECT_NAME_ADD')
export const PROJECT_NAME_UPDATE = generateActionType('PROJECT_NAME_UPDATE')

export const TARGET_SETTING = generateActionType('TARGET_SETTING')
export const TARGET_GROUP_ADD = generateActionType('TARGET_GROUP_ADD')
export const TARGET_GROUP_UPDATE = generateActionType('TARGET_GROUP_UPDATE')

export const PROPOSAL_GOAL = generateActionType('PROPOSAL_GOAL')
export const PROPOSAL_GOAL_ADD = generateActionType('PROPOSAL_GOAL_ADD')
export const PROPOSAL_GOAL_UPDATE = generateActionType('PROPOSAL_GOAL_UPDATE')

export const PROJECT_PROPOSAL = generateActionType('PROJECT_PROPOSAL')

export const SIDEBAR = {
  ...generateActionType('SIDEBAR'),
  SET_IS_EXPANDED: 'SET_IS_EXPANDED_SIDEBAR',
}

export const type = {}
